export const iqesDesignIntent = {
  structureWeight: 0.7,
  cinematicWeight: 0.3,
  productLane: 'Production-ready cinematic Bible game UX',
} as const;

export const iqesColors = {
  canvas: '#030510',
  canvasRaised: '#080A18',
  navy: '#09051A',
  royalPurple: '#4C1D78',
  purpleGlow: '#8B5CF6',
  gold: '#F6BE3A',
  goldBright: '#FFD54A',
  goldSoft: '#FFE8A3',
  ivory: '#FFF8E8',
  parchmentInk: '#120B04',
  mutedWarm: '#E7DED3',
  green: '#1E7A28',
  greenDeep: '#06351A',
  red: '#7A1E1E',
  redDeep: '#351011',
} as const;

export const iqesGradients = {
  appBackground: [iqesColors.canvas, iqesColors.navy, '#12081F'] as const,
  deviceFrame: ['rgba(20, 14, 38, 0.98)', 'rgba(8, 10, 24, 0.98)'] as const,
  feedbackCorrect: ['rgba(5, 53, 25, 0.95)', 'rgba(4, 24, 17, 0.98)'] as const,
  feedbackIncorrect: ['rgba(76, 18, 18, 0.95)', 'rgba(26, 8, 12, 0.98)'] as const,
  trueChoice: [iqesColors.green, '#0E3919'] as const,
  falseChoice: [iqesColors.red, iqesColors.redDeep] as const,
  parchmentWarmth: ['rgba(255, 228, 166, 0.16)', 'rgba(104, 50, 15, 0.08)'] as const,
} as const;

export const iqesTypography = {
  displayFamily: 'Georgia',
  title: {
    fontSize: 29,
    lineHeight: 36,
    fontWeight: '900',
    letterSpacing: 1.8,
  },
  question: {
    fontSize: 18,
    lineHeight: 26,
  },
  verse: {
    fontSize: 19,
    lineHeight: 28,
    fontWeight: '800',
  },
  label: {
    fontSize: 10,
    letterSpacing: 0.8,
  },
} as const;

export const iqesRadii = {
  control: 10,
  answer: 12,
  panel: 16,
  device: 20,
  orb: 999,
} as const;

export const iqesSpacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 18,
  xl: 24,
  xxl: 32,
} as const;

export const iqesGlow = {
  gold: {
    shadowColor: iqesColors.gold,
    shadowOpacity: 0.4,
    shadowRadius: 12,
  },
  device: {
    shadowColor: '#D97706',
    shadowOpacity: 0.24,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
  },
  parchment: {
    shadowColor: iqesColors.gold,
    shadowOpacity: 0.24,
    shadowRadius: 14,
  },
} as const;

export const iqesMotion = {
  tapMs: 150,
  cardTransitionMs: 320,
  rewardMs: 700,
  suspenseMs: 1000,
  verseRevealMs: 1600,
  easing: 'ease-out',
} as const;

export const iqesInteractionStates = {
  resting: {
    borderColor: 'rgba(245, 158, 11, 0.45)',
    backgroundColor: 'rgba(12, 14, 28, 0.82)',
  },
  selected: {
    borderColor: iqesColors.goldBright,
    backgroundColor: 'rgba(197, 133, 16, 0.78)',
  },
  locked: {
    opacity: 0.68,
  },
  correct: {
    borderColor: '#9DF871',
    backgroundColor: 'rgba(12, 96, 39, 0.84)',
  },
  incorrect: {
    borderColor: '#F87171',
    backgroundColor: 'rgba(92, 20, 20, 0.84)',
  },
} as const;

export const iqesExperienceStages = {
  questionAppears: {
    emotion: ['curiosity', 'wonder', 'focus', 'anticipation'],
    motionMs: iqesMotion.cardTransitionMs,
  },
  playerAnswers: {
    emotion: ['participation', 'momentum', 'responsiveness'],
    motionMs: iqesMotion.tapMs,
  },
  answerSubmitted: {
    emotion: ['suspense', 'anticipation', 'pause'],
    motionMs: iqesMotion.suspenseMs,
  },
  feedback: {
    emotion: ['celebration', 'reward', 'encouragement'],
    motionMs: iqesMotion.rewardMs,
  },
  verseReveal: {
    emotion: ['reflection', 'wonder', 'spiritual connection'],
    motionMs: iqesMotion.verseRevealMs,
  },
} as const;
